import { Component, Input } from '@angular/core';
import { CaptureHistoryItem } from '../../../core/models/capture-history-item.model';
import { CaptureHistoryItemTitleComponent } from '../capture-history-item-title/capture-history-item-title.component';
import { CaptureHistoryItemBodyComponent } from '../capture-history-item-body/capture-history-item-body.component';

@Component({
    selector: 'app-capture-history-item-type-base',
    templateUrl: './capture-history-item-type-base.component.html',
    imports: [CaptureHistoryItemTitleComponent, CaptureHistoryItemBodyComponent]
})
export class CaptureHistoryItemTypeBaseComponent {
  @Input() captureHistoryItem: CaptureHistoryItem;

  constructor() {}

  // This is meant as fallback text and shouldn't be shown in practice
  get title() {
    return `Event: ${this.captureHistoryItem.action}`;
  }

  get description() {
    return '';
  }
}
